var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayNow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.54543 3.37868C1.66675 4.25736 1.66675 5.67157 1.66675 8.5V11.5C1.66675 14.3284 1.66675 15.7426 2.54543 16.6213C3.42411 17.5 4.83832 17.5 7.66675 17.5H15.0001C15.3096 17.5 15.4644 17.5 15.5949 17.4886C17.0452 17.3617 18.1951 16.2118 18.322 14.7615C18.3334 14.631 18.3334 14.4762 18.3334 14.1667H13.3334C11.9527 14.1667 10.8334 13.0474 10.8334 11.6667C10.8334 10.286 11.9527 9.16667 13.3334 9.16667H18.3334V8.5C18.3334 5.67157 18.3334 4.25736 17.4547 3.37868C16.5761 2.5 15.1618 2.5 12.3334 2.5H7.66675C4.83832 2.5 3.42411 2.5 2.54543 3.37868ZM5.83341 5.66667C5.28113 5.66667 4.83341 6.11438 4.83341 6.66667C4.83341 7.21895 5.28113 7.66667 5.83341 7.66667H8.33341C8.8857 7.66667 9.33341 7.21895 9.33341 6.66667C9.33341 6.11438 8.8857 5.66667 8.33341 5.66667H5.83341Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 11.6667H13.3333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayNow);
export default __webpack_public_path__ + "static/media/pay_now.2f3233d5269659db71272d404731bdcc.svg";
export { ForwardRef as ReactComponent };